import { Link } from 'react-router-dom';

export function HeaderLogo() {
  return (
    <Link to="/" className="text-xl font-bold tracking-tight text-primary hover:opacity-90">
      90s Shop
    </Link>
  );
}
